
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__paginated/[[...slug]]",
      function () {
        return require("private-next-pages/__paginated/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__paginated/[[...slug]]"])
      });
    }
  